module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/modal-interview-box-image-7c013d742ab574209611195019b2c68f.jpg";